import Moment from "moment"
import DatetimeUtils from "core/gd/utils/datetime-utils"

export default class CalendarHelper {

    // public currentMonth : Moment

    constructor(component, props) {
        this.component      = component
        this.props          = props
        this.highlightRange = this.props.highlightRange

        this.initMonth()
    }

    setProps = (props) => {
        // console.log("set props", props)
        this.props = props
    }

    initMonth() {
        const {initialMonth, selectedDays, focusOnLastDate, minNavigationDate, maxNavigationDate} = this.props
        let res

        if (initialMonth)           res = Moment(initialMonth)
        else if (selectedDays && selectedDays.length > 0)   {
            if (focusOnLastDate) {
                const lastDaysSelection = selectedDays[selectedDays.length-1]
                res = Moment(lastDaysSelection.endDate ? lastDaysSelection.endDate : lastDaysSelection.startDate)
            } else {
                res = Moment(selectedDays[0].startDate)
            }
        }
        else                        res = Moment()

        if (minNavigationDate && res.isSameOrBefore(minNavigationDate, 'month')) {
            res = Moment(minNavigationDate)
        } else if (maxNavigationDate && res.isSameOrAfter(maxNavigationDate, 'month')) {
            res = Moment(maxNavigationDate)
        }

        this.setCurrentMonth(res)
    }

    _getDayStateForSelectionGroup = (moment, selectedData) => {
        const res = {
            isSelected          : false,
            isSelectedSingle    : false,
            isSelectedStart     : false,
            isSelectedEnd       : false,
            inSelectedRange     : false,
        }

        if (selectedData) {
            const { startDate, endDate } = selectedData

            if (startDate && moment.isSame(startDate,'day'))        res.isSelectedStart = true
            if ((res.isSelectedStart && !endDate) ||
                (endDate && moment.isSame(endDate,'day')))          res.isSelectedEnd   = true
            if (res.isSelectedEnd && !startDate)                    res.isSelectedStart = true

            if (!res.isSelectedStart && !res.isSelectedEnd &&
                startDate && moment.isAfter(startDate,'day') &&
                endDate && moment.isBefore(endDate,'day')) res.inSelectedRange = true
        }

        return _.assign(res, {
            isSelected      : res.isSelectedStart || res.isSelectedEnd,
            isSelectedSingle: res.isSelectedStart && res.isSelectedEnd, // single day selection if range has no end date or start date is the same as end date
        })
    }

    _getDayState = (moment) => {
        const res = {
            isSelected          : false,
            isSelectedSingle    : false,
            isSelectedStart     : false,
            isSelectedEnd       : false,
            inSelectedRange     : false,
            isHighlighted       : false,
            isHighlightedSingle : false,
            isHighlightedStart  : false,
            isHighlightedEnd    : false,
            isHighlightedEdge   : false,
            isDisabled          : false,
            selectedClasses     : []
        }

        if (this.highlightRange) {
            const { startDate, endDate } = this.highlightRange


            if (startDate && moment.isSame(startDate,'day'))        res.isHighlightedStart  = true
            if (endDate && moment.isSame(endDate,'day'))            res.isHighlightedEnd    = true

            if (!res.isHighlightedStart && !res.isHighlightedEnd &&
                startDate && moment.isAfter(startDate,'day') &&
                endDate && moment.isBefore(endDate,'day')) res.isHighlighted       = true

            res.isHighlightedEdge   = res.isHighlightedStart || res.isHighlightedEnd
            res.isHighlightedSingle = res.isHighlightedStart && res.isHighlightedEnd // single day highlight if range has no end date or start date is the same as end date
        } else {
            // check every selectedDays range for day states
            _.map(this.props.selectedDays, s=>{
                let dayState = this._getDayStateForSelectionGroup(moment, s)

                // if day has state in any of the selected days range then set corresponding state to true
                if (dayState.isSelected)             res.isSelected             = dayState.isSelected
                if (dayState.isSelectedSingle)       res.isSelectedSingle       = dayState.isSelectedSingle
                if (dayState.isSelectedStart)        res.isSelectedStart        = dayState.isSelectedStart
                if (dayState.isSelectedEnd)          res.isSelectedEnd          = dayState.isSelectedEnd
                if (dayState.inSelectedRange)        res.inSelectedRange        = dayState.inSelectedRange

                // if at least one state is true then add specified className
                if (_.compact([dayState.isSelected, dayState.isSelectedStart, dayState.isSelectedEnd,
                    dayState.inSelectedRange, !!s.className]).length > 0)
                    res.selectedClasses.push(s.className)
            })
        }

        const {minDate, maxDate} = this.props
        res.isDisabled = this.props.disabled ||
            (minDate && moment.isBefore(minDate,'day')) ||
            (maxDate && moment.isAfter(maxDate,'day'))

        if (!res.isDisabled) {
            _.map(this.props.disabledDays, s=>{
                const { startDate, endDate } = s
                if (moment.isSame(startDate,'day') || moment.isSame(endDate,'day') || (moment.isAfter(startDate,'day') && moment.isBefore(endDate,'day'))) res.isDisabled = true
            })
        }

        return res
    }

    setCurrentMonth(moment) {
        this.currentMonth = moment
        this.updateMonth()
    }

    setHighLightRange(highlightRange) {
        this.highlightRange = highlightRange
        this.updateMonth()
    }

    updateMonth() {
        this.today = Moment()

        const firstDate = DatetimeUtils.calendarMonthViewFirstDate(this.currentMonth)

        this.currentMonthDays = []
        for ( let i = 0; i < 6; i++ ) {
            const weekStart = firstDate.clone().add(i,"weeks")
            // check if first or last day of week is in current month
            const weekInMonth = weekStart.isSame(this.currentMonth,"month") || weekStart.clone().add(6,'days').isSame(this.currentMonth,'month')

            // if same height is not required then we do not need 6 weeks to be shown if there are less
            if (!this.props.sameHeightMonths && !weekInMonth) break

            for (let i = 0; i < 7; i++ ) {
                const dayMoment = weekStart.clone().add(i,"days")
                this.currentMonthDays.push(_.assign({
                    moment          : dayMoment,
                    label           : dayMoment.date(),
                    isCurrentMonth  : dayMoment.isSame(this.currentMonth,"month"),
                    isToday         : dayMoment.isSame(this.today, 'day'),
                    isPast          : dayMoment.isBefore(this.today,'day'),
                    isFuture        : dayMoment.isAfter(this.today,'day'),
                    isWeekend       : gd.session.me.weekends().includes(dayMoment.day()),
                }, this._getDayState(dayMoment)))
            }
        }
    }

    increaseMonth() {
        this.setCurrentMonth(this.currentMonth.clone().add(1,'month'))
        this.component.onMonthChanged()
    }

    decreaseMonth() {
        this.setCurrentMonth(this.currentMonth.clone().subtract(1,'month'))
        this.component.onMonthChanged()
    }

    goToToday() {
        this.setCurrentMonth(Moment())
        this.component.onMonthChanged()
    }
}
